var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M17.3116 31.6385L27.0002 26.3749C27.0002 26.3749 6.62515 25.9998 6.87515 16.4999C6.99478 11.9541 5.5779 9.79307 4.06756 8.77533C2.16502 7.4933 -0.117111 8.93569 -1.51176 10.7573L-2.2918 11.7761C-5.17473 15.5416 -4.53324 20.9183 -0.845323 23.8998L7.6334 30.7544C10.3842 32.9783 14.2034 33.3272 17.3116 31.6385Z",
    fill: "#4B5E7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.00775 15.2973C-7.76559 6.84483 13.1735 -4.81567 13.1735 -4.81567C24.6251 -0.875183 28.8751 8.24982 28.8751 8.24982C28.8751 8.24982 14.2501 3.568 10.0001 7.62482C5.75009 11.6816 7.00009 17.9998 7.00009 17.9998V23.8748C7.00009 27.4998 11.5001 29.7498 11.5001 29.7498C11.5001 29.7498 -6.2499 23.7498 -7.00775 15.2973Z",
    fill: "#20E083"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M22.2376 0H11.1807C11.1807 0 14.0035 0.0752767 15.5534 1.43911C17.1032 2.80295 17.1032 5.64576 17.1032 5.64576C17.1032 9.25293 20.0274 12.1771 23.6345 12.1771H31.4943L30.9175 7.64528C30.3613 3.27516 26.6429 0 22.2376 0Z",
    fill: "#4B5E7F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M29.9445 30.4429H11.1807C11.1807 30.4429 14.0035 30.3676 15.5534 29.0038C17.1032 27.6399 17.1032 24.7971 17.1032 24.7971C17.1032 21.1899 20.0274 18.2657 23.6345 18.2657H31.1622L29.9445 30.4429Z",
    fill: "#20E083"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.45651bb30b3763865f614f6d5eb03b76.svg";
export { ForwardRef as ReactComponent };